import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';
 
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) { }

 
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {


    if (request.url.toLowerCase().includes('signal') || request.url.toLowerCase().includes('todaytasks') ) {
      return next.handle(request);
    }
    this.loadingService.busy();
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.idle();
      })
    );
  }
}
